export let authenticated = () => {
    let authed = localStorage.getItem('paymeAuth');

    if (authed === 'U7Eb4PloWr') {
        return true;
    }
}